export default "__VITE_ASSET__3950b79d__"